import { useState, useEffect } from "react";
import {
  getUserList,
  getUserRoles,
} from "../../../services/panel/panelServices";
import CreateUserModal from "../../component/CreateUserModal";
import Pagination from "../../component/Pagination";
import ProfileDetails from "./ProfileDetails";

const PAGE_SIZE = 10;


const formatJoinDate = (value) => {
  const d = new Date(value);
  return isNaN(d)
    ? value || "—"
    : d.toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      });
};

export default function CompanyProfile() {
  const [isUserData, setUserData] = useState([]);
  const [totalUsers, setTotalUsers] = useState(0);
  const [isRoleData, setRoleData] = useState([]);
  const [pageNumber, setPageNumber] = useState(1);
  const [roleId, setRoleId] = useState(0);
  const [usersLoading, setUsersLoading] = useState(false);
  const [showCreateUser, setShowCreateUser] = useState(false);

  useEffect(() => {
    fetchRoleList();
  }, []);

  useEffect(() => {
    fetchUserList();
  }, [pageNumber, roleId]);

  // Same roles as the Add user dropdown — used here for the filter
  const fetchRoleList = async () => {
    try {
      const res = await getUserRoles();

      if (res?.statuscode === 1) {
        setRoleData(res?.data?.roles || []);
      }
    } catch (err) {
      console.log(err.response?.data?.msg || "Failed to fetch roles", "error");
    }
  };

  const fetchUserList = async () => {
    setUsersLoading(true);
    try {
      const params = {
        pageNumber,
        pageSize: PAGE_SIZE,
        roleId, // 0 → all roles
      };
      const res = await getUserList(params);

      if (res?.statuscode === 1) {
        setUserData(res?.records || []);
        setTotalUsers(res?.totalRecords || 0);
      } else {
        setUserData([]);
        setTotalUsers(0);
      }
    } catch (err) {
      console.log(err.response?.data?.msg || "Failed to fetch users", "error");
    } finally {
      setUsersLoading(false);
    }
  };

  const handleRoleChange = (e) => {
    setRoleId(Number(e.target.value));
    setPageNumber(1);
  };

  return (
    <>
      <div className="screen active" id="screen-profile">
        <div className="page-head">
          <div>
            <h1>Company profile</h1>
            <div className="ph-sub">
              Legal details, KYC status and user access
            </div>
          </div>
        </div>
        <ProfileDetails />
        <div className="card" style={{ marginTop: 18 }}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-start",
              gap: 12,
            }}
          >
            <div>
              <div className="card-title">User management</div>
              <div className="card-sub">
                Roles and permissions for this corporate account
              </div>
            </div>
            <button
              className="btn btn-primary btn-sm"
              onClick={() => setShowCreateUser(true)}
            >
              Add user
            </button>
          </div>
          <div className="table-toolbar" style={{ marginTop: 4 }}>
            <div className="field" style={{ margin: 0, minWidth: 200 }}>
              <select value={roleId} onChange={handleRoleChange}>
                <option value={0}>All roles</option>
                {isRoleData.map((r) => (
                  <option key={r.roleID} value={r.roleID}>
                    {r.roleName}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="table-wrap">
            <table className="data-table">
              <tbody>
                <tr>
                  <th>S.No</th>
                  <th>Name</th>
                  <th>Role</th>
                  <th>Mobile</th>
                  <th>Joined</th>
                  <th>Status</th>
                </tr>
                {usersLoading ? (
                  <tr>
                    <td colSpan={6} className="empty-note">
                      Loading users...
                    </td>
                  </tr>
                ) : isUserData.length === 0 ? (
                  <tr>
                    <td colSpan={6} className="empty-note">
                      No users found
                    </td>
                  </tr>
                ) : (
                  isUserData.map((u, i) => (
                    <tr key={u.userID}>
                      <td className="mono">
                        {(pageNumber - 1) * PAGE_SIZE + i + 1}
                      </td>
                      <td>{u.name}</td>
                      <td>
                        <span className="pill pill-info">{u.role}</span>
                      </td>
                      <td className="mono">{u.mobileNo}</td>
                      <td>{formatJoinDate(u.joinDate)}</td>
                      <td>
                        {u.isActive ? (
                          <span className="pill pill-success">Active</span>
                        ) : (
                          <span className="pill pill-neutral">Inactive</span>
                        )}
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
          <Pagination
            pageNumber={pageNumber}
            pageSize={PAGE_SIZE}
            totalRecords={totalUsers}
            onChange={setPageNumber}
            disabled={usersLoading}
            label="users"
          />
        </div>
      </div>
      <CreateUserModal
        open={showCreateUser}
        onClose={() => setShowCreateUser(false)}
        onCreated={fetchUserList}
      />
    </>
  );
}
